import { TableColumns } from '@/components/table/models';
import {
	BEST_PRACTICE_TABLE_COLUMN_IDS,
	PERFORMANCE_METRICS_TABLE_COLUMN_IDS,
	USE_CASES_TABLE_COLUMN_IDS,
} from '../__mocks__';

// Keys that are stored in browser cookies. The login token (X-Hackett-Access-Token) isn't here: it's an HttpOnly
// cookie that only advisory-springboot sets and removes.
export enum COOKIES {
	TARGET_URL = 'TARGET_URL',
	MAINTENANCE_TARGET_URL = 'MAINTENANCE_TARGET_URL',
	INSIDER_SESSION = 'insider_session',
	SP_SESSION = 'sp_session',
	TM_SESSION = 'tm_session',
	VD_SESSION = 'vd_session',
	UI = '_ui',
	SP_REMEMBER = 'sp_remember',
	TM_REMEMBER = 'tm_remember',
	INSIDER_REMEMBER = 'insider_remember',
	VD_REMEMBER = 'vd_remember',
}

export enum TABLE_TYPE_IDS {
	PERFORMANCE_METRICS = 'PERFORMANCE_METRICS',
	BEST_PRACTICES = 'BEST_PRACTICES',
	USE_CASES = 'USE_CASES',
}

export type TableColumnPreferences = {
	[TABLE_TYPE_IDS.PERFORMANCE_METRICS]?: TableColumns<PERFORMANCE_METRICS_TABLE_COLUMN_IDS>;
	[TABLE_TYPE_IDS.BEST_PRACTICES]?: TableColumns<BEST_PRACTICE_TABLE_COLUMN_IDS>;
	[TABLE_TYPE_IDS.USE_CASES]?: TableColumns<USE_CASES_TABLE_COLUMN_IDS>;
};
